import { css } from '@emotion/react'
import { array } from 'prop-types'

import FilterBadge from '@/components/Product/Badges/FilterBadge'
import mediaQueries from '@/layout/media-queries'
import { convertToArray } from '@/utils/func'
import { getDesignationLabel } from '@/utils/products'
import { useEnhancedList } from '@/context/EnhancedList'
import { FILTERS } from '@/constants'

const badgesWrapperCss = css`
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  align-items: center;
  gap: 8px;

  ${mediaQueries.mediumScreen()} {
    flex-wrap: nowrap;
  }
`

const getCompatibilityFilterValues = (filters = []) => {
  const compatibilityFilter = filters.find(
    (filter) => filter.id === FILTERS.COMPATIBILITY.ID
  )
  let selectedValues = convertToArray(compatibilityFilter?.value)

  return selectedValues.map((value) => getDesignationLabel(value))
}

const FilterBadges = ({ filters }) => {
  const { updateFilters } = useEnhancedList()

  if (!filters?.length) {
    return null
  }

  const compatibilityFilterValues = getCompatibilityFilterValues(filters)
  const handleCloseFilter = (selected) => {
    const selectedProduct = String(selected).toLowerCase()
    updateFilters(FILTERS.COMPATIBILITY.ID, selectedProduct, true)
  }

  return (
    <div css={badgesWrapperCss}>
      {compatibilityFilterValues.map((product) => (
        <FilterBadge
          key={product}
          selected={product}
          onClose={() => handleCloseFilter(product)}
        />
      ))}
    </div>
  )
}

FilterBadges.propTypes = {
  filters: array,
}

export default FilterBadges
